import * as React from 'react';
import {PureComponent} from 'react';
import {dataControlStyle} from "./dataControlStyle";

export default class PinIcon extends PureComponent <any, any> {
    render() {
        return (
            <svg viewBox="0 0 200 200" style={{...dataControlStyle}}>
                <g>
                    <path className="st0" d="M95,47.6"/>
                    <path className="st0" d="M78,64.6"/>
                    <line className="st0" x1="95" y1="81.7" x2="95" y2="135.9"/>
                </g>
                <ellipse className="st1" cx="95.3" cy="67.3" rx="15.6" ry="15.4"/>
            </svg>
        );
    }
}